const suppliers = [
    {
      id: 1,
      name: 'شركة الكتب العربية',
      category: 'كتب مدرسية',
      phone: '0795551234',
      email: 'books@arabicbooks.com',
    },
    {
      id: 2,
      name: 'شركة الزي الموحد',
      category: 'ملابس مدرسية',
      phone: '0784445678',
      email: 'uniforms@schoolwear.com',
    },
    {
      id: 3,
      name: 'شركة تجهيزات المدارس',
      category: 'معدات مدرسية',
      phone: '0773339876',
      email: 'supplies@edumaterials.com',
    },
  ];
  
  const expenses = [
    {
      id: 1,
      type: 'صيانة باص',
      amount: 500,
      date: '2024-04-01',
      supplier: 'شركة تجهيزات المدارس',
    },
    {
      id: 2,
      type: 'شراء كتب',
      amount: 1200,
      date: '2024-03-20',
      supplier: 'شركة الكتب العربية',
    },
    {
      id: 3,
      type: 'شراء زي مدرسي',
      amount: 800,
      date: '2024-02-15',
      supplier: 'شركة الزي الموحد',
    },
    {
      id: 4,
      type: 'دفع رواتب',
      amount: 10000,
      date: '2024-04-01',
      supplier: 'رواتب الموظفين',
    },
  ];
  
  export { suppliers, expenses };
  